"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _inputValidationMessage = require("../input-validation-message");
var _fieldBase = _interopRequireDefault(require("../field-base"));
var _icon = _interopRequireDefault(require("../icon"));
var _animator = _interopRequireDefault(require("../animator"));
var _caretDownCircleSolid = _interopRequireDefault(require("../../icons/caret-down-circle-solid"));
var _caretDownCircle = _interopRequireDefault(require("../../icons/caret-down-circle"));
var _wrapWithRequiredAsterisk = _interopRequireDefault(require("../../utils/wrap-with-required-asterisk"));
require("./select-base.css");
var _excluded = ["children", "className", "customFieldStatus", "displayStatus", "enableValidationMessage", "error", "errorMessage", "floatLabelAriaHidden", "hidePlaceholderOption", "hintText", "id", "useInactiveStyle", "label", "modified", "onBlur", "onFocus", "required", "secondaryLabel", "selectedOptionFormatter", "value", "visualStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable complexity */
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    customFieldStatus = _ref.customFieldStatus,
    displayStatus = _ref.displayStatus,
    enableValidationMessage = _ref.enableValidationMessage,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    floatLabelAriaHidden = _ref.floatLabelAriaHidden,
    hidePlaceholderOption = _ref.hidePlaceholderOption,
    hintText = _ref.hintText,
    id = _ref.id,
    _ref$useInactiveStyle = _ref.useInactiveStyle,
    useInactiveStyle = _ref$useInactiveStyle === void 0 ? false : _ref$useInactiveStyle,
    label = _ref.label,
    modified = _ref.modified,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    required = _ref.required,
    secondaryLabel = _ref.secondaryLabel,
    selectedOptionFormatter = _ref.selectedOptionFormatter,
    value = _ref.value,
    visualStyle = _ref.visualStyle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var handleFocus = function handleFocus(ev) {
    if (onFocus) {
      onFocus(ev);
    }
  };
  var handleBlur = function handleBlur(ev) {
    if (onBlur) {
      onBlur(ev);
    }
  };
  var getOptionValue = function getOptionValue(child) {
    if (!(child !== null && child !== void 0 && child.props)) {
      return null;
    }
    return child.props.value || child.props.children;
  };
  var getSelectedOption = function getSelectedOption() {
    // non-breaking space character to preserve space.
    var spaceChar = '\xa0';
    var currentOption = _react["default"].Children.toArray(children).find(function (child) {
      return getOptionValue(child) === value;
    });
    if (!currentOption) {
      // if the currentOption is undefined, it means either nothing has
      // been selected, or the component received a value
      // for the select that doesn't match any options, in this case
      // set it back to unselected.
      return {
        text: spaceChar,
        value: ''
      };
    } else if (selectedOptionFormatter) {
      return {
        text: selectedOptionFormatter({
          text: currentOption.props.children,
          value: currentOption.props.value
        }),
        value: value
      };
    }
    return {
      text: currentOption.props.children,
      value: value
    };
  };
  var fieldId = id || (0, _uniqueId2["default"])('select-base');
  var validationId = "".concat(fieldId, "-validationHint");
  var hintTextId = hintText ? "".concat(fieldId, "-hintText") : null;
  var secondaryLabelId = secondaryLabel ? "".concat(fieldId, "-secondaryLabel") : null;

  // verify props value is one of the current options, if not reset
  var _getSelectedOption = getSelectedOption(),
    currentValue = _getSelectedOption.value,
    currentText = _getSelectedOption.text;
  var labelIsActive = Boolean(currentValue);
  var showValidationMessage = (0, _inputValidationMessage.getDisplayStatus)({
    displayStatus: displayStatus,
    error: error,
    errorMessage: errorMessage
  });
  var ariaDescribeByIds = [showValidationMessage ? validationId : null, hintTextId, secondaryLabelId];
  var labelText = required ? (0, _wrapWithRequiredAsterisk["default"])({
    children: label,
    visualStyle: visualStyle,
    error: error
  }) : label;
  return /*#__PURE__*/_react["default"].createElement(_fieldBase["default"], {
    childId: fieldId,
    className: className,
    customFieldStatus: customFieldStatus,
    enableValidationMessage: enableValidationMessage,
    error: error,
    errorMessage: errorMessage,
    errorMessageDisplayStatus: displayStatus,
    floatLabelActive: labelIsActive,
    floatLabelAriaHidden: floatLabelAriaHidden,
    floatLabelClassName: "select__floatLabel",
    floatLabelText: labelText,
    hintText: hintText,
    hintTextId: hintTextId,
    secondaryLabel: secondaryLabel,
    secondaryLabelId: secondaryLabelId,
    useInactiveStyle: useInactiveStyle,
    useModifiedStyle: modified,
    validationId: validationId,
    visualStyle: visualStyle
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    "aria-describedby": ariaDescribeByIds.filter(Boolean).join(' '),
    "aria-invalid": error,
    "aria-required": required,
    className: "".concat(visualStyle === 'green' ? 'color-textBlack' : '', " select__input"),
    id: id,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: ref,
    value: currentValue
  }, otherProps), !hidePlaceholderOption && /*#__PURE__*/_react["default"].createElement("option", {
    // This element is a placeholder option used to prevent the `Select`
    // from selecting the first actual option by default, which is what the
    // native html select does.
    // Adding 'hidden' as a prop here is a popular recommendation, but makes it so
    // certain screen readers will not announce the first "real" option
    // even though focused on it because they are attempting to read the
    // value of the hidden option (looking at you Chrome/Mac/VoiceOver).
    disabled: true,
    value: ""
  }, otherProps['aria-label'] || label), children), /*#__PURE__*/_react["default"].createElement("span", {
    // This is the element which is seen in the UI when the dropdown is
    // not actively open and shows the currently selected option.
    // It visually contains the floating label. It is hidden from
    // screenreaders as those user agents will read the actual label
    // and the selected value, if applicable.
    "aria-hidden": "true",
    className: "select__selectedTextWrapper flex justify-between relative text-sm"
  }, /*#__PURE__*/_react["default"].createElement(_animator["default"], {
    animation: "fade"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('absolute select__selectedText', {
      'select__selectedText--greenStyle': visualStyle === 'green',
      'select__selectedText--inactiveStyle': useInactiveStyle
    }),
    key: currentText
  }, currentText)), labelIsActive && /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true",
    className: "invisible",
    key: currentText
  }, currentText), /*#__PURE__*/_react["default"].createElement(_animator["default"], null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: (0, _classnames["default"])('caretIcon self-center ml-auto selectIcon', {
      'selectIcon--greenStyle': visualStyle === 'green'
    }),
    key: modified ? "".concat(fieldId, "_solid") : "".concat(fieldId, "_circle"),
    path: modified ? _caretDownCircleSolid["default"] : _caretDownCircle["default"],
    size: "24px"
  }))));
});
/* eslint-enable complexity */
var _default = exports["default"] = Select;